/**
 * LocalStorage操作に関するUtil。
 */
export default class LocalStorageUtil {
	/**
	 * LocalStorageへデータを保存。
	 * @param {string} key LocalStorageへの保存キー
	 * @param {any} data LocalStorageへ保存する情報
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	public static saveLocalStorage(key: string, data: any): void {
		const dataStr = JSON.stringify(data);
		localStorage.setItem(key, dataStr);
	}

	/**
	 * LocalStorageからデータを復元。
	 * @param {string} key LocalStorageへの保存キー
	 * @returns 復元されたデータ。
	 */
	public static loadLocalStorage<T>(key: string): T | null {
		const dataStr = localStorage.getItem(key);
		if (!dataStr) return null;

		return JSON.parse(dataStr) as T;
	}

	/**
	 * LocalStorageのデータを削除。
	 * @param {string} key LocalStorageへの保存キー
	 */
	public static removeLocalStorage(key: string): void {
		localStorage.removeItem(key);
	}
}
